import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-style-guide',
  templateUrl: './style-guide.component.html',
  styles: []
})
export class StyleGuideComponent implements OnInit {

  constructor(private _toastrService: ToastrService, private modalService: NgbModal) { }

  ngOnInit(): void {
    // HOW TO SEE THIS PAGE IN ACTION?
    // LOG IN AS CHR AND GO TO https://localhost/style-guide
  }

  getToastr() {
    this._toastrService.success("Successvol opgeslagen");
  }

  getToastrInfo() {
    this._toastrService.info("Informatie");
  }

  getToastrError() {
    this._toastrService.error("Er is een fout opgetreden");
  }

  openModal(modalContent) {
    this.modalService.open(modalContent, { container: 'body', centered: true, backdrop: 'static' }).result.then(
      (result) => {
      },
      (reason) => {
      },
    );
  }
}

